import { render, staticRenderFns } from "./INDUSTRIES_SERVE.vue?vue&type=template&id=617de740&scoped=true"
import script from "./INDUSTRIES_SERVE.vue?vue&type=script&setup=true&lang=js"
export * from "./INDUSTRIES_SERVE.vue?vue&type=script&setup=true&lang=js"
import style0 from "./INDUSTRIES_SERVE.vue?vue&type=style&index=0&id=617de740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617de740",
  null
  
)

export default component.exports